<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.66634 16.668H13.333V14.168C13.333 13.2513 13.0066 12.4666 12.3538 11.8138C11.7011 11.161 10.9163 10.8346 9.99967 10.8346C9.08301 10.8346 8.29829 11.161 7.64551 11.8138C6.99273 12.4666 6.66634 13.2513 6.66634 14.168V16.668ZM9.99967 9.16797C10.9163 9.16797 11.7011 8.84158 12.3538 8.1888C13.0066 7.53603 13.333 6.7513 13.333 5.83464V3.33464H6.66634V5.83464C6.66634 6.7513 6.99273 7.53603 7.64551 8.1888C8.29829 8.84158 9.08301 9.16797 9.99967 9.16797ZM4.16634 18.3346C3.93023 18.3346 3.73231 18.2548 3.57259 18.0951C3.41287 17.9353 3.33301 17.7374 3.33301 17.5013C3.33301 17.2652 3.41287 17.0673 3.57259 16.9076C3.73231 16.7478 3.93023 16.668 4.16634 16.668H4.99967V14.168C4.99967 13.3207 5.19759 12.5256 5.59342 11.7826C5.98926 11.0395 6.54134 10.4457 7.24967 10.0013C6.54134 9.55686 5.98926 8.96311 5.59342 8.22005C5.19759 7.477 4.99967 6.68186 4.99967 5.83464V3.33464H4.16634C3.93023 3.33464 3.73231 3.25477 3.57259 3.09505C3.41287 2.93533 3.33301 2.73741 3.33301 2.5013C3.33301 2.26519 3.41287 2.06727 3.57259 1.90755C3.73231 1.74783 3.93023 1.66797 4.16634 1.66797H15.833C16.0691 1.66797 16.267 1.74783 16.4268 1.90755C16.5865 2.06727 16.6663 2.26519 16.6663 2.5013C16.6663 2.73741 16.5865 2.93533 16.4268 3.09505C16.267 3.25477 16.0691 3.33464 15.833 3.33464H14.9997V5.83464C14.9997 6.68186 14.8018 7.477 14.4059 8.22005C14.0101 8.96311 13.458 9.55686 12.7497 10.0013C13.458 10.4457 14.0101 11.0395 14.4059 11.7826C14.8018 12.5256 14.9997 13.3207 14.9997 14.168V16.668H15.833C16.0691 16.668 16.267 16.7478 16.4268 16.9076C16.5865 17.0673 16.6663 17.2652 16.6663 17.5013C16.6663 17.7374 16.5865 17.9353 16.4268 18.0951C16.267 18.2548 16.0691 18.3346 15.833 18.3346H4.16634Z"
      :fill="color"
    />
  </svg>
</template>

<script>
export default {
  name: "IconBookingDuration",
  props: {
    color: {
      type: String,
      default: "#F18E35",
    },
  },
};
</script>

<style scoped></style>
